export default {
  data: function () {
    return {
      idToDelete: 0,
      seenDeleteModal: false,
      error: '',
      confirmedRedirect: false,
      seenUnsentMessage: false,
      discardAction: null
    }
  },
  beforeRouteLeave: function (to, from, next) {
    this._set(this.stateObjectKey, this.getState())
    if (this.$refs.addMessage?.hasContent && !this.confirmedRedirect) {
      this.discardAction = to
      this.seenUnsentMessage = true
    } else {
      this.confirmedRedirect = false
      next()
    }
  },
  methods: {
    deleteMessage: function (msgID, messagePermission) {
      this.$store.dispatch('deleteMessage', { conversationID: this.conversation.id, messageID: msgID, showPermission: messagePermission }).then((response) => {
      }, () => {
        this.error = 'Unable to delete message'
      })
      this.seenDeleteModal = false
      this.$forceUpdate()
    },
    handleDiscard: function () {
      this.seenUnsentMessage = false
      this.confirmedRedirect = true
      this.$refs.addMessage.setContents('')
      this.$nextTick(() => {
        if (this.discardAction) {
          if (this.discardAction.fullPath) {
            this.$router.push(this.discardAction.fullPath)
          } else if (this.discardAction.conversation) {
            this.showConvo(this.discardAction.conversation)
          } else if (this.discardAction.mode) {
            this.mode = 'home'
          }
        }
      })
    },
    getState: function () {
      return {
        conversationID: this.conversation.id || 0,
        scroll: this.$refs.messages ? this.$refs.messages.getScrollBottom() : 0,
        message: this.$refs.addMessage ? this.$refs.addMessage.message : ''
      }
    },
    scrollToBottom: function () {
      if (this.$refs.messages) {
        this.$refs.messages.scrollToBottom()
      }
    }
  }
}
